export const INIT = 'INIT'
export const ADD = 'ADD'
export const REMOVE = 'REMOVE'
export const SELECT_APPLICATION = 'SELECT_APPLICATION'
export const SET_STEP = 'SET_STEP'
export const UPDATE_APPLICATION_CV = 'UPDATE_APPLICATION_CV'
